import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { ReferralPartners } from '../screens/referral-partners'

const ReferralPartnersPage: NextPageFC<Empty, PageLayoutOwnProps> = () => ReferralPartners()

ReferralPartnersPage.layout = PageLayout

ReferralPartnersPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
}

ReferralPartnersPage.headProps = {
	title: pagesTitles[PagesPath.referralPartners].title,
	description: 'Привлекайте заёмщиков и зарабатывайте вместе с нами',
	ogImageName: 'wow.jpg',
}

export default ReferralPartnersPage
